export default {
	ninzhidexinlande: 'Teman perjalananmu yang dipercaya',
	zainalizhaodaonixiangyao: 'Cari penerbangan Cheap Anda ingin ke mana?',
	zhaodaoyitiaoshihenideluxian: 'Find a route that matches you',
	zuijindedijiajipiao: 'Recent low price airline tickets',
	qingshuruhuoxuanzenidechengshi: 'Silakan masukkan atau pilih tujuan Anda',
	wodeyuding: 'Pesanan Saya',
	kehuzhiyuan: 'Bantuan',
	denglu: 'Masuk',
	suoyouhangban: 'Semua Bandara',
	baokuoshuifei: 'Termasuk Pajak & Biaya',
	baokuotuoyunxingli: 'Sudah Termasuk Bagasi',
	yingwen: 'Inggris',
	zhongzhuan: 'Pemberhentian Sementara',
	shijian: 'Waktu',
	gangbi: 'Dolar Hongkong',
	yuyan: 'Bahasa',
	bizhong: 'Mata Uang',
	jipiao: 'AIR',
	xuesheng: 'STUDENT',
	guyong: 'DOMESTIC HELPER',
	haiyuan: 'SEAMAN',
	lvxingtuan: 'Tour Group',
	zuche: 'Rental Mobil',
	laihui: 'Pulang Pergi',
	dancheng: 'Sekali Jalan',
	duogemudidi: 'Multi-kota',
	you: 'Dari',
	dao: 'Ke',
	chufashijian: 'Pergi',
	fanchengshijian: 'Pulang',
	toudengcang: 'First Class',
	lvke: 'Penumpang',
	cangdeng: 'Cabin Class',
	jingjicang: 'Ekonomi',
	shangwucang: 'Bisnis',
	gaojijingjicang: 'Ekonomi Premium',
	souxun: 'Cari',
	nianling: 'usia',
	sui: 'Tahun',
	remenyouhui: 'Penawaran Menarik',
	remenjingdian: 'Destinasi pilihan',
	chengren: 'Dewasa',
	xiaotong: 'Anak',
	yinger: 'Bayi',
	souxunhangban: 'Cari Penerbangan',
	liaojiegengduo: 'Pelajari lebih lanjut',
	guanyu: 'About',
	guanyuwomen: 'Tentang kami',
	lianluowomen: 'Hubungi Kami',
	fukuan: 'Pembayaran',
	tiaokuanyuxize: 'Syarat & Ketentuan',
	yinsizhengce: 'Kebijakan Privasi',
	fuwu: 'Layanan',
	hangban: 'Pesawat',
	jiudian: 'Hotels',
	changjianwenti: 'Pertanyaan yang sering diajukan',
	xueshengjipiao: 'STUDENT AIR',
	guyongjipiao: 'DOMESTIC HELPER AIR',
	haiyuanjipiao: 'SEAMAN AIR',
	dingyueyoujian: 'Berlangganan Email',
	nideyoujian: 'Email Anda',
	qingshuru: 'Silahkan Pilih ',
	womenjieshou: 'Kami Menerima',
	paixushaixuan: 'urutkan & filter',
	remenhangbanyouhui: 'Penawaran penerbangan populer',
	chengshi: 'Kota',
	yaozuodeshiqing: 'Atraksi',
	huodong: 'Aktivitas',
	ranggoupiaogengrongyi: "Taro-TripMengadakan konsep 'membuat pembelian tiket lebih mudah', menyediakan pengguna layanan tiket online berkualitas tinggi, memudahkan perjalanan pelanggan, dan berkontribusi ke perkembangan industri dan ekonomi turisme. Indonesia, Indonesia",
	banquansuoyou: 'hak cipta',
	xiangtongchengshitishi: 'Kota berangkat dan kota tujuan tidak bisa sama',
};
